<template>
	<div class="Modal">
		<div class="grid">
			<div class="image-section">
				<img class="marker-image" v-if="file != null"
					 :src="'/files/getById?height=600&width=600&file_id=' + file.id" :alt="file.file_name">
				<a class="Button primary" target="_blank" :href="'/bestanden/' + projectMarker.company.id">FOTO'S</a>
			</div>
			<div class="info-section">
				<p class="top-p">
					<span>{{
							projectMarker.company.firstname + ' ' + (projectMarker.company.infix ? projectMarker.company.infix + ' ' : '') + projectMarker.company.lastname
						}}</span>
					<span>{{
							projectMarker.company.visitingaddress_street + ' ' + projectMarker.company.visitingaddress_streetnumber
						}}</span>
					<span>{{
							projectMarker.company.visitingaddress_zipcode + ' ' + projectMarker.company.visitingaddress_city
						}}</span>
				</p>
				<p class="bottom-p">
					<span>{{ projectMarker.company.email }}</span>
					<span>{{ projectMarker.company.phone }}</span>
				</p>
			</div>
			<execution-appointment-create-form
				:project-marker="projectMarker"
				:is-reschedule="isReschedule"
				:is-support="isSupport"
			></execution-appointment-create-form>
		</div>
	</div>
</template>

<script>
import ExecutionAppointmentCreateForm from "./ExecutionAppointmentCreateForm.vue";

export default {
	name: "ExecutionAppointmentCreateModal",

	components: {
		ExecutionAppointmentCreateForm
	},

	props: {
		projectMarker: Object,
		file: Object,
		isReschedule: Boolean,
		isSupport: Boolean
	},

	mounted() {
		this.$events.on("executionAppointment/created", () => {
			this.$events.emit("map/closePopup");
			this.$emit("close");
		});
	}
}
</script>

<style scoped>
.Modal {
	padding: 0;
	color: #273844;
}

/deep/ .grid {
	min-height: 600px;
	display: grid;
	grid-template-columns: 30% 70%;
	grid-template-rows: 75% 25%;
	grid-template-areas:
      "image-section detail-section"
      "info-section detail-section";
}

.marker-image {
	grid-column: 1;
	grid-row: 1;
	border-top-left-radius: 3px;
	overflow: hidden;
}

/deep/ .image-section {
	grid-area: image-section;
}

.Button {
	margin: 24px;
	display: block;
	border-radius: 5px;
	text-align: center;
	font-weight: bold;
	font-size: 1rem;
	text-decoration-line: none;
	align-self: flex-end;
}

.image-section img {
	grid-column: 1;
	grid-row: 1;
	border-top-left-radius: 3px;
	overflow: hidden;
	height: calc(100% - 75px);
	object-fit: cover;
}

.info-section {
	grid-area: info-section;
	grid-column: 1;
	grid-row: 2;
	padding: 24px;
	align-self: end;
}

.top-p {
	margin-top: 0;
}

.bottom-p {
	margin-bottom: 0;
}

.info-section span {
	display: flex;
	flex-direction: row;
}
</style>
